<template>
  <input-select
    v-if="structures.length > 1" 
    name="choice_structure"
    :value="structure"
    @input="(newValue) => {changeStructureAndReloadInfos(newValue.id)}"
    :datas="structures"
    libelle=""
    :empty-case="false"
    :value-is-object="true"
    icon="building"
    :always-enabled-when-neoppass-form="true"
  />
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import InputSelect from './Inputs/InputSelect.vue';

export default {
  components:{
    InputSelect,
  },

  methods:{
    ...mapActions({
      'changeStructure' : 'auth/changeStructure',
    }),

    async changeStructureAndReloadInfos(idStructure){
      await this.changeStructure(idStructure);
      this.$router.go();
    }
  },

  computed:{
    ...mapGetters({
      user: 'auth/user',
      structure: 'auth/structure',
    }),

    structures(){
      return this.user.companies.reduce((acc, company) => [...acc, {...company, value: company.name}], []);
    }
  }
    
};
</script>